import { FC, memo } from 'react'
import { Alert, FormInstance } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import sclasses from '../SetCourseClassDirectionModal/index.module.css'
import spclasses from '../SetCourseClassDirectionModal/purchase.module.css'
import { ICustomClass } from '../SetCourseClassDirectionModal/SetClassModalBody'
import { InputNew } from '@UI/InputNew'
import DiscountInput from './DiscountInput'
import EnrollDateCheckbox from './EnrollDateCheckbox'
import { RequestCreateLeadPaymentLink } from '@/api/types/crm.types'
import { useWatch } from 'antd/es/form/Form'
import SelectClass from './components/SelectClass/SelectClass'

type FieldType = Omit<RequestCreateLeadPaymentLink, 'lead_id'>

export interface ClassFieldsProps {
  form: FormInstance<any>
  classesState: { value?: ICustomClass[]; loading: boolean; retry: () => void }
  filterSort: (optionA: any, optionB: any) => number
  validateDiscount: (rule: any, value: number) => Promise<void>
  priceWatch: number | null
}

const ClassFields: FC<ClassFieldsProps> = memo((props) => {
  const { form, classesState, filterSort, validateDiscount, priceWatch } = props

  const classIdWatch = useWatch('class_id', form) as number | null
  const selectedClass = classesState.value?.find(
    (item) => item.id === classIdWatch,
  )

  return (
    <>
      <div className={sclasses.inputWithLabel}>
        <div className={sclasses.inputLabel}>Класс</div>
        <FormItem<FieldType>
          name="class_id"
          rules={[{ required: true, message: 'Выберите класс' }]}
          noStyle
        >
          <SelectClass
            className={spclasses.select}
            classesState={classesState}
          />
        </FormItem>
      </div>
      {selectedClass &&
        (selectedClass?.one_pay ? (
          <>
            <div className={sclasses.textDescription}>
              Базовая стоимость, мес: {selectedClass.amount} ₽
            </div>
            <div className={sclasses.inputWithLabel}>
              <FormItem<FieldType>
                name="first_price"
                rules={[
                  {
                    required: true,
                    message: 'Укажите стоимость первой оплаты',
                  },
                  {
                    type: 'number',
                    min: 0,
                    message: 'Цена не может быть отрицательной',
                    transform: (value) => Number(value),
                  },
                ]}
                noStyle
              >
                {/* @ts-ignore */}
                <InputNew
                  className={spclasses.input}
                  title="Стоимость 1-ой оплаты (в руб.)"
                  type="number"
                  placeholder={0}
                />
              </FormItem>
            </div>
            <div className={sclasses.inputWithLabel}>
              <FormItem<FieldType>
                name="price"
                rules={[
                  { required: true, message: 'Укажите цену' },
                  {
                    type: 'number',
                    min: 0,
                    message: 'Цена не может быть отрицательной',
                    transform: (value) => Number(value),
                  },
                ]}
                noStyle
              >
                {/* @ts-ignore */}
                <InputNew
                  className={spclasses.input}
                  title="Цена/мес (в руб.)"
                  type="number"
                  placeholder={0}
                />
              </FormItem>
            </div>
            <div className={sclasses.inputWithLabel}>
              <FormItem<FieldType>
                name="discount"
                rules={[
                  {
                    type: 'number',
                    min: 0,
                    message: 'Скидка не может быть отрицательной',
                    transform: (value) => (value ? Number(value) : undefined),
                  },
                  { validator: validateDiscount },
                ]}
                noStyle
              >
                <DiscountInput
                  totalAmount={priceWatch || 0}
                  className={spclasses.input}
                />
              </FormItem>
            </div>
            <div className={sclasses.inputWithLabel}>
              <FormItem<FieldType> name="enroll_date" noStyle>
                <EnrollDateCheckbox />
              </FormItem>
            </div>
          </>
        ) : (
          <Alert
            message="Оплата за данный класс производится отдельно по каждому направлению"
            type="info"
          />
        ))}
    </>
  )
})

export default ClassFields
